import React from "react";
import styled from "styled-components";
import { FlexContainer, FlexDiv, Button } from "@/components/Atoms";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V1";
import NextImage from "next/image";

function BannerSection(props) {
  const { handleScrollToSection = () => {}, healthDetailsData = [] } =
    props || {};
  return (
    <Wrapper
      banner={healthDetailsData?.hero?.hero_background}
      bannerMobile={healthDetailsData?.hero?.hero_background_mob}
    >
      <FlexContainer flexDirection={"column"} position="relative" zIndex={"1"}>
        <WrapperDiv>
          <Heading
            variant={"heading1"}
            fontSize={["24px", "30px", "30px"]}
            color={theme.colors.white}
            lineHeight={"normal"}
          >
            {healthDetailsData?.hero?.hero_title}
          </Heading>
          <Typography
            fontFamily={"var(--font-600)"}
            variant={"paragraph1"}
            color={theme.colors.white}
          >
            {healthDetailsData?.hero?.hero_subtitle}
          </Typography>
          {healthDetailsData?.hero?.banner_cta && (
            <Btn
              variant={"primary1"}
              bgColor={theme.colors.yellow}
              hoverColor={`${theme.colors.yellow}eb`}
              fontFamily={"var(--font-700)"}
              fontSize={"18px"}
              onClick={handleScrollToSection}
            >
              {
                <>
                  {healthDetailsData?.hero?.banner_cta}{" "}
                  {/* {healthDetailsData?.hero?.hero_signup_primary_pricing
                    ?.package_top_price && (
                    <>
                      <StrikeThrough>
                        {
                          healthDetailsData?.hero?.hero_signup_primary_pricing
                            ?.package_top_price
                        }
                      </StrikeThrough>{" "}
                    </>
                  )} */}
                  {/* {
                    healthDetailsData?.hero?.hero_signup_primary_pricing
                      ?.package_slashed_price
                  } */}
                  {
                    healthDetailsData?.hero?.hero_signup_primary_pricing
                      ?.package_top_price
                  }
                </>
              }
            </Btn>
          )}
        </WrapperDiv>
      </FlexContainer>
    </Wrapper>
  );
}

export default BannerSection;
const Wrapper = styled(FlexDiv)`
  background: url("${({ banner }) => banner}") center no-repeat;
  background-size: cover;
  position: relative;
  padding: 50px 0;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: ${theme.colors.linearGradBlue};
    pointer-events: none;
  }
  @media only screen and (max-width: 767px) {
    background: url("${({ bannerMobile }) => bannerMobile}") center no-repeat;
    background-position-y: top;
    background-size: 100%;
    padding: 6.7% 0;
  }
  @media only screen and (max-width: 349px) {
    background-size: cover;
  }
`;
const WrapperDiv = styled(FlexDiv)`
  flex-direction: column;
  max-width: 361px;
  @media only screen and (max-width: 767px) {
    max-width: 100%;
    align-items: center;
    text-align: center;
  }
`;
const Btn = styled(Button)`
  margin-top: 25px;
  cursor: default !important;
  @media only screen and (max-width: 1159px) {
    font-size: 15px;
  }
  @media only screen and (max-width: 439px) {
    margin-top: 13px;
  }
`;
export const StrikeThrough = styled.del`
  font-family: inherit;
  color: inherit;
  line-height: inherit;
  font-size: inherit;
`;
const Heading = styled(Typography)`
  @media only screen and (max-width: 767px) {
    max-width: 275px;
    margin: 0 auto;
  }
`;
